module.exports = __webpack_public_path__ + "img/user-icon4.ed54b2ff.png";